<template>
  <v-container fluid pa-0 ma-0>
    <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
      <v-layout row wrap>
        <v-flex xs12 style="display: flex; align-items: center">
          <v-btn
            v-if="teams.teamsRows.length > 0 && teams.teamsRows[0].Saved"
            color="primary"
            @click="deleteTeams(teams.teamsId)"
          >
            Delete from {{ isQuote ? 'Quote' : 'Order' }}
          </v-btn>
        </v-flex>

        <v-flex xs12 md3 pt-3>
          <v-layout wrap row>
            <v-flex sm9 md8 lg8>
              <vonex-text
                ref="txt"
                v-model="NumberOfRows"
                :label="
                  connectionType === 'extension'
                    ? 'Number of Extensions'
                    : 'Number of Channels'
                "
                type="number"
                :options="fieldConditions"
                name="txt"
                :min="1"
                :rule="minNum"
                @keyup="changeRows"
              />
            </v-flex>
            <v-flex xs2>
              <v-btn title="Add Row" class="iconBtn" @click="onAdd">
                <v-icon>add</v-icon>
              </v-btn>
              <br />
              <v-btn title="Remove Row" class="iconBtn" @click="onRemove">
                <v-icon>remove</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- <v-flex xs12 md9>
          <v-radio-group v-model="planGroup" column value="true" class="ptop-0">
            <v-radio
              name="ondesk"
              value="ondesk"
              label="ONdesk Plans"
            ></v-radio>
            <v-radio
              name="lineshare"
              value="lineshare"
              label="LineShare Plans"
              :disabled="existingOndeskCust"
            ></v-radio>
          </v-radio-group>
        </v-flex> -->
      </v-layout>
      <v-layout row wrap>
        <table class="table table table-striped table-bordered mobile-table">
          <thead>
            <tr>
              <th scope="col" style="width: 3vw"></th>
              <th scope="col" style="width: 3vw">ID</th>
              <th scope="col" style="width: 4vw">Ext.</th>
              <th scope="col">Extension Name</th>
              <th scope="col" style="width: 15vw">Contract Length</th>
              <th scope="col" style="width: 15vw">
                <div>Plan</div>
                <div>
                  <v-btn
                    v-if="planGroup !== 'lineshare'"
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('ratePlanID')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col" style="width: 15vw">
                <div>Device</div>
                <div>
                  <v-btn
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('handsetID')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
              <th scope="col">
                <div>ANI</div>
                <div>
                  <v-btn
                    color="primary"
                    small
                    round
                    title="copy down"
                    @click="copyDown('ani')"
                  >
                    Copy Down
                  </v-btn>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(extension, index) in rows" :key="index">
              <td align="center">
                <div v-show="extension.saved">
                  <v-icon color="green">check_circle</v-icon>
                  <v-icon @click="removeTeamsRow(index)">delete</v-icon>
                </div>
              </td>
              <td>
                <vonex-text
                  v-model="extension.id"
                  class="form-control custom-td"
                  :options="fieldConditions"
                  :name="'id' + index"
                  hide-details
                  :readonly="true"
                />
              </td>
              <td>
                <vonex-text
                  v-model="extension.extension"
                  class="form-control custom-td"
                  :rule="'required|min_value:1'"
                  :options="fieldConditions"
                  :name="'quantity' + index"
                  hide-details
                />
              </td>
              <td>
                <vonex-text
                  v-model="extension.extensionName"
                  class="form-control custom-td"
                  :options="fieldConditions"
                  :name="'quantity' + index"
                  hide-details
                />
              </td>
              <td>
                <vonex-select
                  v-model="extension.contractLength"
                  class="form-control custom-td"
                  name="contractLengthMonths"
                  :items="loadContractSelection()"
                  item-text="description"
                  item-value="value"
                  :rule="'contractMonths'"
                  :options="fieldConditions"
                  :disabled="index > 0"
                  hide-details
                  dense
                  flat
                  @change="copyDown('contractLength')"
                />
              </td>
              <td>
                <vonex-autocomplete
                  v-model="extension.ratePlanID"
                  :options="fieldConditions"
                  class="form-control custom-td"
                  :rule="'required|planId'"
                  :name="'ratePlanID' + index"
                  :disabled="index > 0 && planGroup == 'lineshare'"
                  :items="validRatePlans(extension.contractLength)"
                  item-value="ratePlanID"
                  item-text="ratePlanDescription"
                  hide-details
                  dense
                  flat
                  @change="updateRowPlans(index)"
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.ratePlanDescription }}
                    </span>
                  </template>
                  <template slot="no-data">
                    {{
                      extension.contractLength >= 0
                        ? 'No plans available'
                        : 'Choose contract length'
                    }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.ratePlanDescription }}
                    </span>
                  </template>
                </vonex-autocomplete>
              </td>
              <td>
                <vonex-autocomplete
                  v-model="extension.handsetID"
                  :options="fieldConditions"
                  class="form-control custom-td"
                  :rule="
                    (!isManagementFee(extension.ratePlanID) &&
                      validHandsets(extension.ratePlanID).length) > 0
                      ? 'required|planId'
                      : ''
                  "
                  :name="'ratePlanID' + index"
                  :disabled="index > 0 && planType == 'mincharge'"
                  hide-details
                  dense
                  flat
                  :items="validHandsets(extension.ratePlanID)"
                  item-value="handsetID"
                  item-text="model"
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.manufacturer.description }}
                      {{ data.item.model }}
                    </span>
                  </template>
                  <template slot="no-data">
                    {{
                      extension.ratePlanID == '' || extension.ratePlanID == 0
                        ? 'Choose a Rate Plan first'
                        : 'No devices available'
                    }}
                  </template>
                  <template slot="item" slot-scope="data" class="ellipsis">
                    {{ data.item.manufacturer.description }}
                    {{ data.item.model }}
                  </template>
                </vonex-autocomplete>
              </td>
              <td>
                <vonex-text
                  v-model="extension.ani"
                  :options="fieldConditions"
                  class="form-control custom-td"
                  :name="'ani' + index"
                  :rule="extension.ani ? 'phonenumber' : ''"
                  hide-details
                />
              </td>
            </tr>
          </tbody>
          <tfoot>
            <!--
           
            <tr>
              <td align="center" colspan="6"></td>
              <td
                style="padding: 5px 7px !important"
                align="center"
                colspan="1"
              >
                Management Fee
              </td>
              <td
                style="padding: 5px 7px !important"
                colspan="1"
                class="currency"
              >
                {{ totalManagementFee | currency }}
              </td>
            </tr> -->
            <tr>
              <td align="center" colspan="6"></td>
              <td
                style="padding: 5px 7px !important"
                align="center"
                class="font-weight-bold"
                colspan="1"
              >
                Total (handset value + freight):
              </td>
              <td
                style="padding: 5px 7px !important"
                class="currency font-weight-bold"
                colspan="1"
              >
                {{ totalCost | currency }}
              </td>
            </tr>
            <tr v-if="setup == 'setupConfig'">
              <td align="center" colspan="6"></td>
              <td
                style="padding: 5px 7px !important"
                align="center"
                class="currency currency font-weight-bold"
                colspan="1"
              >
                Teams Setup Fee
              </td>
              <td
                style="padding: 5px 7px !important"
                colspan="1"
                class="currency font-weight-bold"
              >
                {{ totalSetupFee | currency }}
              </td>
            </tr>
          </tfoot>
        </table>
        <p class="text-xs-right red--text d-block">For any 24mth Contract Terms selected, a 5% discount will apply. For any 36mth Contract Terms selected, a 10% discount will apply. Discount will show on the first bill and will discontinue at the end of the contract term.</p>      
      </v-layout>
      <v-radio-group v-model="setup" @change="updateConfigType" name="setup">
        <v-container fluid>
          <v-flex xs12>
            <v-title>Setup</v-title>
            <v-card>
              <v-card-text>
                <v-flex xs12>
                  <v-flex>
                    <v-radio
                      :label="`Setup Fee: $250 for first 5 extensions, $125 for every 5 after`"
                      value="setupConfig"
                      color="primary"
                    ></v-radio>
                  </v-flex>
                  <v-flex>
                    <v-radio
                      :label="`No Setup fee, doing own config`"
                      name="diy"
                      value="diy"
                      color="primary"
                    ></v-radio>
                  </v-flex>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>
      </v-radio-group>

      <v-container fluid>
        <v-flex xs12>
          <v-title>Ongoing Teams Configuration</v-title>
          <v-card>
            <v-card-text>
              <v-flex xs12>
                <v-flex>
                  <vonex-checkbox
                    v-model="hasOnGoingTeamConfig"
                    :label="configTitle"
                    value="addOn"
                    :input-value="hasOnGoingTeamConfig"
                    @change="updatehasOnGoingTeamConfig"
                    color="primary"
                  ></vonex-checkbox>
                  <span class="text-red text-caption ml-4">
                    <small>
                      <i>*allows access to unlimited change requests</i>
                    </small>
                  </span>
                </v-flex>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-container>

      <v-flex sm12>
        <v-btn
          color="primary"
          name="sbmt"
          @click="save"
          :disabled="invalid || rows.some((e) => e.ratePlanID == 0)"
        >
          Save Teams
        </v-btn>
        <message-alert :component="message"></message-alert>
      </v-flex>
    </ValidationObserver>
  </v-container>
</template>
<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import {
  mapTeamsFields,
  mapTeamsMultiRowFields,
  mapRatePlanMultiRowFields,
  mapHardwareMultiRowFields,
} from '../store/modules/orders';
const { mapActions: mapTeamsActions, mapMutations: mapTeamsMutations } =
  createNamespacedHelpers(`orders/Teams`);
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapActions: mapHardwareActions } =
  createNamespacedHelpers(`orders/hardware`);
const { mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);
import Utils from '@/mixins/utils.mixin';

export default {
  name: 'CreateTeams',
  mixins: [Utils],
  data() {
    return {
      planGroup: 'ondesk',
      NumberOfRows: 1,
      planType: 'capped',
      setup: 'setupConfig',
      hasOnGoingTeamConfig: false,
    };
  },
  computed: {
    ...mapOrderState(['customer']),
    ...mapTeamsMultiRowFields({ rows: 'teams.teamsRows' }),
    ...mapRatePlanMultiRowFields({ ratePlans: 'rows' }),
    ...mapTeamsFields(['teams', 'message']),
    ...mapTeamsFields({ connectionType: 'teams.connectionType' }),
    ...mapGetters('orders', [
      'isQantas',
      'isResidential',
      'isQuote',
      'isExistingCustomer',
      'hasNoDDProvided',
    ]),
    ...mapHardwareMultiRowFields(['handsets']),
    minNum: function () {
      return this.teams.connectionType == 'trunk'
        ? 'min_value:1'
        : this.planType == 'capped'
        ? 'min_value:1'
        : 'min_value:1';
    },
    totalCost: function () {
      let result = this.rows
        .map((x) =>
          this.handsets
            .filter((y) => y.handsetID == x.handsetID)
            .reduce((a, c) => parseFloat(c.rrpEx * 1.1) + a, 0.0)
        )
        .reduce((a, c) => parseFloat(a + c), 0.0);

      let rowCount = this.rows
        .map((x) =>
          this.handsets
            .filter((y) => y.handsetID == x.handsetID)
            .reduce((a, c) => (parseFloat(c.rrpEx) > 0 ? 1 : 0) + a, 0.0)
        )
        .reduce((a, c) => parseFloat(a + c), 0.0);
      let freight = rowCount == 0 ? 0.0 : (rowCount - 1) * 7.5 + 20.0;
      return result + freight;
    },
    total: function () {
      try {
        if (this.planType === 'mincharge')
          return this.ratePlans.filter(
            (e) => e.ratePlanID == this.rows[0].ratePlanID
          )[0].monthlyRetail;
        else {
          let newrows = this.rows
            .map(
              (x) =>
                this.ratePlans.filter((e) => e.ratePlanID == x.ratePlanID)[0]
                  .monthlyRetail *
                (this.teams.connectionType == 'extension' ? 1 : x.quantity)
            )
            .reduce((prev, next) => prev + next);
          return newrows;
        }
      } catch (err) {
        return 0;
      }
    },
    totalSetupFee: function () {
      try {
        if (
          this.setup == 'diy' ||
          this.setup == 'addOn' ||
          this.setup == 'addOn'
        ) {
          return 0;
        }
        if (this.rows.length <= 5) {
          return 250;
        } else {
          let exist = this.rows.length - 5;
          return 250 + 125 * Math.floor(Math.ceil(exist / 5));
        }
      } catch (err) {
        return 0;
      }
    },
    totalManagementFee: function () {
      let fee = 0;
      this.rows.map((x) => {
        let rp = this.ratePlans.filter((e) => e.ratePlanID == x.ratePlanID)[0];
        if (rp) {
          if (
            (rp &&
              rp.ratePlanDescription &&
              rp.ratePlanDescription
                .toLowerCase()
                .includes('management fee')) ||
            (rp.ratePlanDetails &&
              rp.ratePlanDetails.toLowerCase().includes('management fee'))
          ) {
            fee += rp.monthlyRetail;
          }
        }
      });
      return fee;
    },
    existingOndeskCust() {
      let vm = this;
      return (
        vm.customer.customer.ubAccountNo > 0 &&
        vm.customer.customer.hasOndeskService === true
      );
    },
    configTitle() {
      return 'Teams Voice Config Add-on for $59 per month';
    },
  },
  methods: {
    ...mapCustomerActions(['getCustomer']),

    ...mapTeamsActions([
      'updateRows',
      'addRow',
      'addRow',
      'removeRows',
      'populateTeams',
      'setMessage',
      'removeHardware',
      'removeTeamsFromOrder',
    ]),
    ...mapHardwareActions(['getHandsets']),
    ...mapTeamsMutations([
      'changeQuantity',
      'setConfigType',
      'setOnGoingTeamConfig',
      'removeTeamsRow',
    ]),
    connectionChange: function () {
      let vm = this;

      if (vm.teams.connectionType == 'trunk' && vm.rows.length > 1) {
        if (!vm.rows[0].saved)
          vm.$dialog
            .confirm('Switching to Trunk will delete rows, are you sure?')
            .then(function () {
              vm.removeRows(1).then(function () {
                vm.changeQuantity(vm.rows.length);
                vm.removeHardware();
                vm.NumberOfRows = vm.rows.length;
              });
            })
            .catch(function () {
              vm.NumberOfRows = vm.rows.length;
              return;
            });
        else {
          vm.removeRows(1).then(() => {
            vm.changeQuantity(vm.rows.length);
            vm.removeHardware();
            vm.NumberOfRows = vm.rows.length;
          });
        }
      }
      if (vm.teams.connectionType == 'trunk') {
        if (vm.rows.length < 1) {
          vm.changeQuantity(2);
          vm.removeHardware();
          vm.NumberOfRows = 1;
        } else {
          vm.changeQuantity(vm.rows.length);
          vm.removeHardware();
          vm.NumberOfRows = vm.rows.length;
        }
      }
      if (
        vm.teams.connectionType == 'extension' &&
        vm.teams.teamsRows.length < 2
      ) {
        vm.NumberOfRows = 2;
        vm.changeRows();
      }
    },
    changeRows: function () {
      let vm = this;
      var oldVal = 0 || vm.rows.length;
      var newVal = vm.NumberOfRows;
      if (parseInt(oldVal, 10) > parseInt(newVal, 10)) {
        vm.$dialog
          .confirm('You are about to delete rows, are you sure?')
          .then(function () {
            vm.removeRows(newVal).then(function () {
              vm.NumberOfRows = vm.rows.length;
              vm.changeQuantity(vm.rows.length);
            });
          })
          .catch(function () {
            vm.NumberOfRows = oldVal;
            vm.changeQuantity(vm.rows.length);
            return;
          });
      } else {
        if (newVal > vm.rows.length)
          for (var i = oldVal; i < newVal; i++) {
            if (vm.teams.connectionType === 'extension') {
              vm.addRow(vm.isQantas);
              vm.rows[i].extension = 500 + i;
            }
          }
      }
    },
    onAdd() {
      this.NumberOfRows++;
      if (this.teams.connectionType === 'trunk') {
        this.changeQuantity(this.teams.teamsRows[0].quantity + 1);
      }
      this.$refs.txt.$emit('keyup');
    },
    onRemove() {
      this.NumberOfRows--;
      if (this.teams.connectionType === 'trunk') {
        this.changeQuantity(this.teams.teamsRows[0].quantity - 1);
      }
      this.$refs.txt.$emit('keyup');
    },
    checkPlan: function (ratePlan) {
      return ratePlan.usageType === 'tea';
    },
    validRatePlans: function (months) {
      return this.ratePlans
        .filter((x) => x.archived == false)
        // .filter((x) => x.qantas == this.isQantas)
        .filter((x) => x.residential == this.isResidential)
        .filter((x) => x.usageType.toLowerCase() == 'teams')
        .filter((e) => {
          // If Plans with Handset Rental: only show grenkeFinance plans
          if (this.isQantas) {
            return e.grenkeFinance === true;
          }
          // If not Plans with Handset Rental: exclude grenkeFinance plans
          if (!this.isQantas && e.grenkeFinance === true) {
            return false;
          }
          return true;
        })
        .filter((m) => {
          return parseInt(months) == parseInt(m.contractMonths);
        });
    },
    copyDown: function (column) {
      let vm = this;
      let id = vm.rows[0][column];

      for (var i = 0; i < vm.rows.length; i++) {
        vm.rows[i][column] = id;
        if (column == 'contractLength') {
          vm.rows[i]['ratePlanID'] = 0;
          vm.rows[i]['handsetID'] = 0;
        }
        if (column == 'ratePlanID') vm.rows[i]['handsetID'] = 0;
      }
    },
    deleteRow(index) {
      let rows = this.rows.filter(
        (x) => x.extension != this.rows[index].extension
      );
      if (rows.length > 0) {
        this.updateRows().then(() => {
          this.NumberOfRows = this.rows.length;
        });
      }
    },
    deleteTeams(teamsId) {
      let vm = this;

      this.$dialog
        .confirm(
          'You are about to delete TEAMS from this order, this cannot be undone, are you sure?'
        )
        .then(() => {
          vm.removeTeamsFromOrder(teamsId).then(() => {
            vm.$router.push('order-summary');
          });
        });
    },
    async save() {
      let vm = this;
      this.teams.hardware = 'none';
      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (result) {
            try {
              await vm.updateRows();
            } catch (err) {
              vm.setMessage({
                message: 'Unable to save: ' + err.message,
                httpStatus: 500,
              });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    loadContractSelection() {
      let selections = [{ description: '0 months', value: 0 }];

      if (this.hasNoDDProvided && !this.isQuote) return selections;

      if (!this.isQantas) {
        selections.push({ description: '12 months', value: 12 });
        selections.push({ description: '36 months', value: 36 });
        // if (this.planGroup === 'lineshare' && this.existingLineshareCust) {
        //   let filteredMonths = selections.filter((x) => x.value !== 12);
        //   return filteredMonths;
        // }
        // if (this.planGroup === 'lineshare' && !this.existingLineshareCust) {
        //   selections.push({ description: '24 months', value: 24 });
        // }
      }

      if (this.isQantas) {
        selections = [];
        selections.push({ description: '36 months', value: 36 });
        // if (this.planGroup === 'lineshare' && this.existingLineshareCust) {
        //   let filteredMonths = selections.filter((x) => x.value !== 36);
        //   return filteredMonths;
        // }
      }

      return selections;
    },
    validHandsets(ratePlanID) {
      if (ratePlanID == 0) return [];

      let rawHandsets = this.handsets
        .filter((x) => x.status === 'active')
        .filter((x) => x.availableOnRatePlans.includes(ratePlanID))
        .sort((a, b) => a.viewOrder - b.viewOrder);

      return rawHandsets.sort(function compare(a, b) {
        if (
          a.manufacturer.description.toLowerCase() <
          b.manufacturer.description.toLowerCase()
        )
          return;
        if (
          a.manufacturer.description.toLowerCase() >
          b.manufacturer.description.toLowerCase()
        )
          return 1;
        return 0;
      });
    },
    isManagementFee(ratePlanID = 0) {
      let rp = this.ratePlans.filter((e) => e.ratePlanID == ratePlanID)[0];
      if (rp) {
        return (
          (rp &&
            rp.ratePlanDescription &&
            rp.ratePlanDescription.toLowerCase().includes('management fee')) ||
          (rp.ratePlanDetails &&
            rp.ratePlanDetails.toLowerCase().includes('management fee'))
        );
      }
    },

    updateRowPlans(index) {
      let vm = this;
      if (vm.planGroup == 'lineshare' && index == 0) {
        vm.rows.forEach((el) => (el.ratePlanID = vm.rows[0].ratePlanID));
      }
      vm.updateHandset(index);
    },
    updateHandset(index) {
      let vm = this;
      vm.rows[index].handsetID = 0;
      vm.updateHandset(index);
    },
    updateHandset(index) {
      let vm = this;
      vm.rows[index].handsetID = 0;
    },
    updateConfigType(value) {
      this.setConfigType(value);
    },
    updatehasOnGoingTeamConfig(val) {
      this.setOnGoingTeamConfig(val);
    },
  },
  mounted() {
    let vm = this;
    vm.getHandsets();

    vm.populateTeams(this.isQantas)
      .then((data) => {
        if (data) {
          vm.setup = data && data.configType ? data.configType : 'setupConfig';
          vm.hasOnGoingTeamConfig = data.hasOnGoingTeamConfig;
          this.setOnGoingTeamConfig(vm.hasOnGoingTeamConfig);

          if (data.teamsRows.length > 0) {
            let currentPlan = this.ratePlans.filter((x) => {
              if (x.ratePlanID === data.teamsRows[0].ratePlanID) return x;
            });

            if (currentPlan.length > 0)
              this.planGroup = currentPlan[0].ratePlanDescription
                .toLowerCase()
                .includes('lineshare')
                ? 'lineshare'
                : 'ondesk';
          } else {
            vm.addRow(vm.isQantasvm.isQantas);
          }
        }

        vm.NumberOfRows = vm.rows.length;
      })
      .catch((err) => {
        vm.setMessage({
          message: 'Unable to retreive: ' + err.message,
          httpStatus: 500,
        });
      });
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/custom-styles.scss';
</style>
